"use client"

import { usePathname } from "next/navigation"
import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react"

interface NavigationContextType {
  isFirstMount: boolean
  currentPath: string | null
}

const NavigationContext = createContext<NavigationContextType>({
  currentPath: null,
  isFirstMount: true,
})

export function NavigationProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const pathname = usePathname()
  const initialPathnameRef = useRef(pathname)
  const [isFirstMount, setIsFirstMount] = useState(true)

  useEffect(() => {
    if (pathname !== initialPathnameRef.current) {
      setIsFirstMount(false)
    }
  }, [pathname])

  return (
    <NavigationContext.Provider
      value={{
        currentPath: pathname,
        isFirstMount,
      }}
    >
      {children}
    </NavigationContext.Provider>
  )
}

export function useNavigation() {
  return useContext(NavigationContext)
}
